module.exports = __webpack_public_path__ + "static/media/bg3.0c8d3e05.webp";